import { HomeworkSubmittedTable } from './HomeworkSubmittedTable';
export default HomeworkSubmittedTable;
